import { makeStyles } from '@mui/styles';

const styles = makeStyles(theme => ({
  emptyHealthServiceCardHeight: {
    height: "400px"
  },
  marginTop: {
    marginTop: "20px"
  },
  textCenter: {
    textAlign: "center"
  },
  icon: {
    "& svg": {
      color: "#0000ff"
    }
  }
}));
export default styles;